module.exports = __webpack_public_path__ + "static/media/4D.b9f0e0af.svg";